import satzung from "../resources/history/Satzung_Eggspatzen.pdf";


function History() {

    const Alt = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/history/alt01.jpg"
            alt="alt"
            className="col-md-12 inlineImage"
        />
      );

      const Alt2 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/history/alt02.jpeg"
            alt="alt2"
            className="col-md-12 inlineImage"
        />
      );

      const Alt3 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/history/alt03.jpeg"
            alt="alt3"
            className="col-md-12 inlineImage"
        />
      );

      const Wappen = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/history/egweil.jpg"
            alt="egweil"
            className="col-md-11 inlineImage"
        />
      );

    return (
        <div className="Geschichte">
            <div className="container">
                <p className="col-md-12 pagecontent">VEREINSGESCHICHTE</p>
                <p className="col-md-12 heading_midsize">Geschichte der Eggspatzen Egweil</p>
                <div className="row justify-content-md-center">
                    <p className="col-md-5">
                        Im Jahr 1986, ein Jahr vor der offiziellen Gründung der "Eggspatzen", wurde aus einer spontanen Idee der Egweiler Feuerwehr der Grundstein für die zukünftige Faschingsgesellschaft gelegt. Die Floriansjünger beschäftigten sich schon seit längerer Zeit mit dem Gedanken, einen Faschingsumzug mit Prinzenpaar, Garde und Hofstaat auf die Beine zu stellen.
                        <br /><br />
                        {/* <img className="inlineImage" src={alt}></img> */}
                        <Alt></Alt>
                        <br /><br />
                        Das erste inoffizielle Prinzenpaar wurde sehr schnell gefunden: Prinz Oliver und Prinzessin Petra. Kurzerhand wurden die Tänze von Maria Simon einstudiert. Im Jahr 1987 fand somit der erste offizielle Faschingsball mit Prinzenpaar und Garde in Egweil statt.
                        <br /><br />
                        Das Vereinsleben der "Eggspatzen" begann am 6. November 1987 mit dreizehn Personen im Gasthaus Heindl in Egweil. Ihr Ziel war es, die Veranstaltungen in Egweil zu beleben und einen jährlich stattfindenden Rosenmontagsumzug zu organisieren. Bei der unmittelbar durchgeführten Wahl eines Präsidiums wurde Rudolf Ernst einstimmig zum Präsidenten gewählt - er ist heute Ehrenpräsident der Eggspatzen. Die weiteren Vorstandschaft setzte sich demnach aus Franz Luidl (Vize-Präsident), Erna Riegler (erster Schatzmeister), Richard Koch (zweiter Schatzmeister) und Josef Schimmer (Schriftführer) zusammen. Die weiteren Gründungsmitglieder wurden zum Elferrat ernannt.
                        <br /><br />
                        Durch Ableitung des Ortsnamens einigte man sich auf den Vereinsnamen "Faschingsgesellschaft  Eggspatzen" und dem Schlachtruf "Egg-Narria". Die Gemeinde Egweil zeigte sich großzügig, indem sie der Faschingsgesellschaft ein ansehnliches Startkapital zur Verfügung stellte, mit dem die ersten Vorbereitungen getroffen werden konnten.  Des weiteren wurden für die Gardemädchen Verhaltensregeln definiert und schriftlich festgehalten. Kurz nach der Gründung wurde sogar ein Lied geschrieben, das heute wahrscheinlich nur noch die Gründungsväter kennen. Im ersten Jahr tanzten die Gardemädchen auf insgesamt 15 Bällen in Egweil, Buxheim, Konstein, Eitensheim und Rennertshofen.
                        <br /><br />
                        {/* <img className="col-md-11 inlineImage" src={logo}></img> */}
                        <Wappen></Wappen>
                    </p>

                    <p className="col-md-5">
                        In den folgenden Jahren wurde immer härter trainiert, aufwändige  Kostüme entworfen und schwierige Choreografien einstudiert. Durch den selbstlosen Einsatz der Vorstandschaft, der Trainer, der Tänzer/-innen und der Prinzenpaare der einzelnen Jahre wurde der Verein schnell weit über die Grenzen Egweils hinaus bekannt.
                        <br /><br />
                        Durch den großen Erfolg und in weiser Voraussicht der damaligen Vorstandschaft wurde 1993 erstmals eine Nachwuchsgarde gegründet. "Späher" des Präsidiums machten sich auf die Suche, um sich nach geeigneten und begeisterungsfähigen Gardemädchen umzusehen. Damit war also auch der Grundstein für eine erfolgreiche Nachwuchsarbeit gelegt.
                        <br /><br />
                        {/* <img className="inlineImage" src={alt2}></img> */}
                        <Alt2></Alt2>
                        <br /><br />
                        Aufgrund der unermüdlichen Arbeit der Vorstandschaft und der großen Akzeptanz der Egweiler Bürger wurde für die Saison 1996 das erste Mal eine Kinder-Garde eingeführt. Die Mädchen im Alter von acht bis zehn Jahren sind mit großer Begeisterung und Freude an ihre neue Aufgabe herangetreten und konnten ihre einstudierten Tänze im Fasching an vielen Bällen präsentieren.
                        <br /><br />
                        {/* <img className="col-md-12 inlineImage" src={alt3}></img> */}
                        <Alt3></Alt3>
                        <br /><br />
                        Im Jahr 1997 zählte der Verein bereits über 250 Mitglieder, die aktive Mannschaft besteht seit diesem Jahr aus einer Kinder-, einer Teenie-, einer großen Garde und natürlich aus einem Prinzenpaar und zählt damit etwa 60 Personen. Seit dem Jahre 2000 wird die Kindergarde auch von einem Prinzenpaar angeführt.
                        <br /><br />
                        Nicht zu vergessen sind die Techniker und Elferräte, die die Fäden im Hintergrund ziehen und für Licht, Musik und Requisiten etc. sorgen. In jedem Jahr gab es viel Applaus und Anerkennung - aber auch immer wieder Verletzungen und Tränen, sei es vor Freude oder aus Schmerzen. In einer Ingolstädter Regionalzeitung konnte man vor einigen Jahren lesen, dass die "Garden eine verschworene Gemeinschaft" seien. Die einzelnen Vereine kennen sich "untereinander mal mehr, mal weniger", und dass diese "kurze, aber sehr intensive Zeit für die meisten unvergesslich bleibt".
                        <br /><br />
                        Im Moment können die Eggspatzen auf viele erfolgreiche Jahre zurückblicken. Auch in Zukunft werden wir uns bemühen, den Zuschauern aus Nah und Fern ein fesselndes und professionelles Show-Programm zu bieten.
                    </p>

                </div>
                <br /><br />

                <div className="row justify-content-md-center">
                    <p className="heading_midsize">Vereinssatzung</p>
                    <p className="col-md-10">Eine Vereinssatzung ist die rechtliche Grundlage eines Vereins und legt dessen interne Regeln fest. In Deutschland müssen Vereine, die als eingetragene Vereine (e.V.) anerkannt werden, eine Satzung haben, die den Vorgaben des Bürgerlichen Gesetzbuchs (BGB) entspricht, insbesondere § 57 bis § 60 BGB. </p>
                    <a href={satzung} className="download_link heading_smallsize">
                        <p>
                           Zur Vereinssatzung 
                        </p>
                    </a>
                </div>
                <br /><br />
            </div>
        </div>
    );
}

export default History;